import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const LANGUAGES = [
  { code: 'pl', label: 'PL', name: 'Polski' },
  { code: 'en', label: 'EN', name: 'English' },
];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div className="px-3 py-2">
      <p className="text-[10px] text-sidebar-foreground/50 uppercase tracking-wide mb-1.5">
        {t('language.switchLanguage')}
      </p>
      <div className="flex gap-1">
        {LANGUAGES.map(lang => (
          <button
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            title={lang.name}
            className={cn(
              'px-2.5 py-1 rounded text-xs font-semibold transition-colors',
              currentLang === lang.code
                ? 'bg-primary text-primary-foreground'
                : 'text-sidebar-foreground/60 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
            )}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}
